import { SwivlNavigateFunction } from "../../Models/NavBar/useSwivlNavigate";

export class NavigationHelper {
    static navFunction?: SwivlNavigateFunction 
    static navigate = (to?:string) => {
        NavigationHelper.navFunction(to);
    }
}